import { createTheme } from '@mui/material/styles'

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#2196F3'
    },
    background: {
      default: '#1a1a1a',
      paper: '#2d2d2d'
    },
    text: {
      primary: '#ffffff',
      secondary: '#a0a0a0'
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none'
        }
      }
    }
  }
})
